export default __webpack_public_path__ + "68e2c3268711b8b9c0c00ea82255470f.svg";